module.exports = __webpack_public_path__ + "img/no-funds-header-image.a6ddd114.svg";